import moment from 'moment';

export const getAgeByUnixTimeStamp = (timeStamp) => {
  const currentDate = moment();
  return currentDate.diff(moment(timeStamp), 'years');
}